import { INFORMATION_ACTION , ACCORDION_INFORMATION_UI_TYPE, ACCORDION_INFORMATION_TRIGGER, SLIDER_INFORMATION_TRIGGER, SLIDER__INFORMATION_UI_TYPE } from '../config';
import { pushTrackingObject } from '../helpers';

/**
 * fire accordions toggle tracking
 */
export const accordionTracking = (informationName) => {
    pushTrackingObject('information', {
        information_action: INFORMATION_ACTION,
        information_name: informationName ? informationName.toLowerCase() : '',
        information_ui_type: ACCORDION_INFORMATION_UI_TYPE,
        information_trigger: ACCORDION_INFORMATION_TRIGGER,
    });
};
/**
 * fire images slider tracking
 */
 export const imageSliderTracking = (informationName, step) => {
    pushTrackingObject('information', {
        information_action: INFORMATION_ACTION,
        information_name: informationName ? informationName.toLowerCase() : '',
        information_ui_type: SLIDER__INFORMATION_UI_TYPE,
        information_trigger: SLIDER_INFORMATION_TRIGGER,
        information_step: step,
    });
};
